import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const JamforElavtal = lazy(() => import("@/pages/elavtal/JamforElavtal"));

export const Route = createFileRoute("/elavtal/jamfor")({
  head: () => seoHead("/elavtal/jamfor"),
  component: () => <JamforElavtal />,
});
